import './bootstrap';
import './Vue/init';
import './general/heroSlider';
import './general/lightbox';
import tcon from './vendor/transformicons';

window.tcon = tcon;

/*
|------------------------------------------------------------------------------------------------------------------
| Menu
|------------------------------------------------------------------------------------------------------------------
*/

// Collapse all on .site-content click
$('.site-content').on('click', () => {
  $('.navbar-collapse.show').collapse('hide');
});

// Menu - Toggle tcon and dropdown
const $mainNav = $('.main-nav');
$('#primary-nav').on('show.bs.collapse', () => {
  $('.navbar-collapse.show').collapse('hide'); // Hide others
  $mainNav.addClass('main-nav--open');
  $('#primary-nav-toggler').addClass('tcon-transform');
}).on('hide.bs.collapse', () => {
  $mainNav.removeClass('main-nav--open');
  $('#primary-nav-toggler').removeClass('tcon-transform');
});


// Menu - Search
$('#primary-nav-search').on('show.bs.collapse', () => {
  setTimeout(() => {
    const el = document.getElementById('primary-nav-search-input');

    if (el) {
      el.focus();
    }
  }, 300);
}).on('hide.bs.collapse', () => {
  const el = document.getElementById('primary-nav-search-input');

  if (el) {
    el.blur();
  }
});

// Scroll to #contact-form
$mainNav.find('[href="#contact-section"]').click((e) => {
  e.preventDefault();
  $('html,body').animate({ scrollTop: $('#contact-section').offset().top }, 'slow');
  $('#primary-nav').collapse('hide');
});

// Set slim nav on scroll
const $menu = $('.main-nav:not(.main-nav--slim)');
$(window).scroll(() => {
  if ($(window).scrollTop() > 64) {
    $menu.addClass('main-nav--slim scrolled');
  } else {
    $menu.removeClass('main-nav--slim scrolled');
  }
});


/*
|-------------------------------------------------------------------------------------------------------------------
| Category Menu
|-------------------------------------------------------------------------------------------------------------------
*/

// Category List
$('.category-list__toggler').click(function (e) {
  e.preventDefault();
  $(this).parent('.category-list__item').toggleClass('expand');
});

$('#category-list-mobile').on('show.bs.collapse', () => {
  tcon.transform('.category-list-mobile-toggler');
  $('#cat-btn-title').text('Lukk');
}).on('hide.bs.collapse', () => {
  tcon.revert('.category-list-mobile-toggler');
  $('#cat-btn-title').text('Produktoversikt');
});


/*
|-------------------------------------------------------------------------------------------------------------------
| Forms
|-------------------------------------------------------------------------------------------------------------------
*/

$('.js-form-loading').on('submit', function () {
  $(this).find('figure').addClass('loading-overlay');
});


/*
|-------------------------------------------------------------------------------------------------------------------
| Filter
|-------------------------------------------------------------------------------------------------------------------
*/

const $filterGroupContainer = $('#filter_group_container');

function runFilter(query = '') {
  $filterGroupContainer.each(function () {
    const queryFilterEnabled = query.length > 0;

    $(this).find('[data-name]').each(function () {
      if (queryFilterEnabled) {
        const name = $(this).data('name');

        if (name.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
          $(this).slideDown(200);
        } else {
          $(this).slideUp(200);
        }
      } else {
        $(this).slideDown(200);
      }
    });
  });
}

$('#filter_query').keyup((event) => {
  runFilter(event.target.value);
});

$('#filter_reset').click(() => {
  $('#filter_query').val('');
  runFilter();
});
